export enum CompanyActions{
  CLEAR_COMPANY = "CLEAR_COMPANY",
  SET_COMPANY = "SET_COMPANY",
}

export interface ICompanyState{
  id: number;
  name: string;
  alias: string;
  cleanable: boolean;
  connected: boolean;
}